import { Injectable } from "@angular/core";
import { GenericService, ErrorConfig } from "./generic.service";
import { environment } from "src/environments/environment";
import { ISAPI } from "is-lib";
import { ServerResponse } from "../models/ServerResponse";
import { Observable } from "rxjs";
import { UsersService } from "./users.service";

@Injectable({
    providedIn: 'root'
})

export class AddressesService{
    constructor(private _httpService: GenericService, private _userService: UsersService) { }
    
    getDistricts(errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<any>>{
        return this._httpService.get(`${environment.apiUrl}Addresses/${this._userService.userCountryCode}/Districts`, true, undefined, undefined, errorConfig);
    }

    getPostalCodePT(zipCode: string, callLoader: boolean = true, errorConfig?: ErrorConfig | boolean) {
        return this._httpService.get<any>(`${environment.apiUrl}Addresses/PT/FullPostalCode/${zipCode}`, true, undefined, undefined, errorConfig);
    }

    getPostalCodeES(zipCode: string, callLoader: boolean = true, errorConfig?: ErrorConfig | boolean) {
        return this._httpService.get<any>(`${environment.apiUrl}Addresses/ES/FullPostalCode/${zipCode}/AddressHierarchy`, true, undefined, undefined, errorConfig);
    }

    getParishes(countyId: number, callLoader: boolean = true, errorConfig?: ErrorConfig | boolean) {
        return this._httpService.get<any>(`${environment.apiUrl}Addresses/${(this._userService.userCountryCode == undefined ? localStorage.getItem('lang') : this._userService.userCountryCode)}/Counties/${countyId}/Parishes`, true, undefined, undefined, errorConfig);
    }
}